import Honeybadger from 'honeybadger-js';
import React from 'react';
import ReactDOM from 'react-dom';
import { VstLoader } from 'vstui';
import DevicesContainer from './js/components/devices-container';
import Layout from './js/components/layout';
import Redirect from './js/components/redirect';
import RefundDetail from './js/components/refund-detail';
import RefundsContainer from './js/components/refunds-container';
import Resource from './js/components/resource';
import ResourcesContainer from './js/components/resources-container';
import TransactionDetail from './js/components/transaction-detail';
import User from './js/components/user';
import './styles/mulligan.scss';

Honeybadger.configure({
  apiKey: 'caf208b8',
  environment: ENV.environment,
  revision: `${process.env.SHA}`
});

const title = "VitalSource Account Center"

const getAlohomoraUrl = (path = "") => {
  return `https://${ENV.alohomoraHost}${path}?redirect_uri=${encodeURIComponent(window.location.href.replace(/(\/login)|(\/logout)|(\/redirect)/ig, ""))}&brand=${Mulligan.brandParam || window.location.hostname}`
}

const getStoreRedirectUrl = () => {
  return `https://${ENV.alohomoraHost}?redirect_uri=${encodeURIComponent(ENV.storeOrderHistory)}&method=jwt&brand=${Mulligan.brandParam || window.location.hostname}`
}

const MulliganController = {

  index(modal) {
    let page = ["user", "devices", "resources", "transactions"].find((page) => Mulligan.Brand.AccountCenter.Sidebar[page]);
    // redirect to first available if user info is not enabled for this brand
    if (page && page !== "user") { MulliganRouter.setRoute(`/${page}`); return; }

    document.title = title + ": " + i18n.t("base.user");
    ReactDOM.render(
      <Layout page="user"
        component={<User modalOpen={modal} />} />,
      document.getElementById('root')
    );
  },

  notFound() {
    // not sure the best way to handle this w/o switching the controller to an instance
    // eslint-disable-next-line
    MulliganRouter.setRoute('/');
  },

  login() {
    ReactDOM.render(
      <Redirect url={getAlohomoraUrl()} hideMessage={true} />,
      document.getElementById('root')
    );
  },

  // The logout page is necessary for alohomora logout - it logs out of alohomora after any necessary Jigsaw session clearing.
  logout() {
    ReactDOM.render(
      <Redirect url={getAlohomoraUrl("/logout")} hideMessage={true} />,
      document.getElementById('root')
    );
  },

  devices() {
    document.title = title + ": " + i18n.t("base.devices");
    ReactDOM.render(
      <Layout page="devices"
        component={<DevicesContainer />} />,
      document.getElementById('root')
    );
  },

  resources(tab) {
    document.title = title + ": " + i18n.t("base.resources");
    ReactDOM.render(
      <Layout page="resources"
        component={<ResourcesContainer tab={tab || "ancillaries"} />} />,
      document.getElementById('root')
    );
  },

  resource(tab, isbn) {
    document.title = title + ": " + i18n.t("base.resources");
    ReactDOM.render(
      <Layout page="resources"
        component={<Resource isbn={isbn} />} />,
      document.getElementById('root')
    );
  },

  transactions() {
    ReactDOM.render(
      <Redirect url={getStoreRedirectUrl()} hideMessage={true} />,
      document.getElementById('root')
    );
  },

  transactionDetail(number) {
    /* console.log("details!");*/
    document.title = title + ": " + i18n.t("base.transactions");
    ReactDOM.render(
      <Layout page="transactions"
        component={<TransactionDetail orderNumber={number} />} />,
      document.getElementById('root')
    );
  },

  refunds() {
    document.title = title + ": " + i18n.t("base.refunds");
    ReactDOM.render(
      <Layout page="transactions" component={<RefundsContainer />} />,
      document.getElementById('root')
    );
  },

  refundRequest(transactionId, itemNumber) {
    document.title = title + ": " + i18n.t("base.transactions");
    ReactDOM.render(
      <Layout page="transactions" component={<TransactionDetail orderNumber={transactionId} refundItemNumber={itemNumber} />} />,
      document.getElementById('root')
    );
  },

  refundRestrictions(transactionId) {
    document.title = title + ": " + i18n.t("base.transactions");
    ReactDOM.render(
      <Layout page="transactions" component={<TransactionDetail orderNumber={transactionId} refundRestrictions={true} />} />,
      document.getElementById('root')
    );
  },

  refundDetail(number) {
    document.title = title + ": " + i18n.t("base.refunds");
    ReactDOM.render(
      <Layout page="transactions" component={<RefundDetail number={number} />} />,
      document.getElementById('root')
    );
  },

  redirect(url) {
    ReactDOM.render(
      <Redirect url={window.decodeURIComponent(url)} />,
      document.getElementById('root')
    );
  },

  loader() {
    ReactDOM.render(
      <div className="loading-app"><VstLoader /></div>,
      document.getElementById('root')
    );
  }

};


let MulliganRouter = new DirectorRouter({
  '/': MulliganController.index,
  '/user/profile': MulliganController.index,
  '/user/profile/:modal': MulliganController.index,
  '/devices': MulliganController.devices,
  '/settings': MulliganController.devices,
  '/resources': MulliganController.resources,
  '/resources/:tab': MulliganController.resources,
  '/resources/:tab/:isbn': MulliganController.resource,
  '/transactions': MulliganController.transactions,
  '/purchases': MulliganController.transactions,
  '/transactions/refunds': MulliganController.refunds,
  '/transactions/:id': MulliganController.transactionDetail,
  '/transactions/:trans_id/request-refund/:id': MulliganController.refundRequest,
  '/transactions/refunds/:id': MulliganController.refundDetail,
  '/transactions/:id/refund-restrictions': MulliganController.refundRestrictions,
  '/login': MulliganController.login,
  '/login/:failure/:email': MulliganController.login,
  '/redirect/:url': MulliganController.redirect,
  '/logout': MulliganController.logout,
  '.*': MulliganController.notFound
});

export default MulliganRouter;
export { MulliganController, MulliganRouter };

